import { render, staticRenderFns } from "./ExcelImportDialog.vue?vue&type=template&id=16015804&scoped=true"
import script from "./ExcelImportDialog.vue?vue&type=script&lang=js"
export * from "./ExcelImportDialog.vue?vue&type=script&lang=js"
import style0 from "./ExcelImportDialog.vue?vue&type=style&index=0&id=16015804&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16015804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16015804')) {
      api.createRecord('16015804', component.options)
    } else {
      api.reload('16015804', component.options)
    }
    module.hot.accept("./ExcelImportDialog.vue?vue&type=template&id=16015804&scoped=true", function () {
      api.rerender('16015804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/logistics/company/postcode/components/ExcelImportDialog.vue"
export default component.exports